import {redirectFun} from "../../common/js/redirectUrl";
redirectFun('video');
import Vue from 'vue'
import App from './App'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import '../../common/css/toast.css'
import Toast from '../../common/js/toast'

Vue.use(VueAwesomeSwiper)
Vue.use(Toast)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/module/video/video.js